import { mapActions } from 'vuex'
import debounce from 'lodash.debounce'
import CitySummary from './components/city-summary/city-summary.vue'
import SummaryChart from '@/components/summary-chart/summary-chart.vue'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'ProductionSummary',
  components: {
    CitySummary,
    SummaryChart
  },
  data() {
    return {
      /**
       * см.структуру здесь https://dosta-admin.apidoc.handh.ru/#operation/v2MainTodayResults
       */
      productionSummary: null
    }
  },
  computed: {
    dataCharts() {
      if (this.productionSummary) {
        const result = {
          count: [],
          avg_check: [],
          revenue: []
        }
  
        this.productionSummary.orders_by_date.forEach(item => {
          const keys = Object.keys(item)
            .filter(key => key !== 'date')
          keys.forEach(key => {
            result[key].push({
              date: this.$moment(item.date, 'YYYY-MM-DD').format('DD MMM'),
              value: item[key]
            })
          })
        })
        return result
      }
    }
  },
  mounted() {
    this.setPageInfo()
    this.$bus.$on('refresh-managers-info', this.setPageInfoDebounce)
  },
  beforeDestroy() {
    this.$bus.$off('refresh-managers-info', this.setPageInfoDebounce)
  },
  methods: {
    ...mapActions({
      getProductionSummary: 'productionSummary/getProductionSummary'
    }),
    
    numberWithSeparator,

    async setPageInfo() {
      /**
       * отмена происходит в самом экшене
       */
      this.productionSummary = await this.getProductionSummary()
    },
    setPageInfoDebounce: debounce(function() {
      this.setPageInfo()
    }, 300)
  }
}